import { HttpErrorResponse } from '@angular/common/http';
import { ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';
import { ConnectionException } from 'src/core/common/domain/exceptions/connection-exception';

export class NoConnectionException extends ConnectionException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'NoConnectionException';
  }

  static fromError(error: HttpErrorResponse | Error): NoConnectionException {
    return new this(error.message, error);
  }
}
